import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import api from '../services/api';

export const authStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      
      login: async (email, senha) => {
        try {
          const response = await api.post('/auth/login', { email, senha });
          const { access_token, user } = response.data;
          
          try {
            const photoResponse = await api.get('/usuarios/profile/photo');
            user.fotoPerfil = photoResponse.data.fotoPerfil;
          } catch (photoError) {
            console.log('Foto de perfil não disponível');
          }
          
          set({
            user,
            token: access_token,
            isAuthenticated: true,
          });
          
          return { success: true };
        } catch (error) {
          return { 
            success: false, 
            error: error.response?.data?.message || 'Erro ao fazer login' 
          };
        }
      },
      
      logout: () => {
        set({
          user: null,
          token: null,
          isAuthenticated: false,
        });
      },
      
      updateProfile: async () => {
        try {
          const response = await api.get('/auth/profile');
          const user = response.data;
          
          try {
            const photoResponse = await api.get('/usuarios/profile/photo');
            user.fotoPerfil = photoResponse.data.fotoPerfil;
          } catch (photoError) {
            console.log('Foto de perfil não disponível');
          }
          
          set({ user });
        } catch (error) {
          console.error('Erro ao atualizar perfil:', error);
        }
      },
      
      updateProfilePhoto: async (photoUrl) => {
        const { user } = get();
        if (user) {
          set({ 
            user: { 
              ...user, 
              fotoPerfil: photoUrl 
            } 
          });
        }
      },
      
      hasPermission: (module, action = 'view') => {
        const { user } = get();
        if (!user) return false;
        
        if (
          user?.cargo?.nome?.toLowerCase().includes('admin') ||
          (user?.cargo?.nivelAcesso >= 9)
        ) return true;
        
        if (user.permissoes?.[module]?.includes(action)) return true;
        
        if (user.cargo?.permissoes?.[module]?.includes(action)) return true;
        
        return false;
      },
    }),
    {
      name: 'auth-storage',
    }
  )
);